<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-yujingfenzu`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.2 6.6H16.8C17.0895 6.6 17.4 6.8673 17.4 7.29412V9.88235C17.4 10.3092 17.0895 10.5765 16.8 10.5765H7.2C6.91049 10.5765 6.6 10.3092 6.6 9.88235V7.29412C6.6 6.8673 6.91049 6.6 7.2 6.6zM7.2 13.4237H16.8C17.0895 13.4237 17.4 13.691 17.4 14.1178V16.7061C17.4 17.1329 17.0895 17.4002 16.8 17.4002H7.2C6.91049 17.4002 6.6 17.1329 6.6 16.7061V14.1178C6.6 13.691 6.91049 13.4237 7.2 13.4237z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.046" cy="15.412" r=".647" :fill="useCurrentColor ? 'currentColor' : 'currentColor'"/><circle cx="9.046" cy="8.588" r=".647" :fill="useCurrentColor ? 'currentColor' : 'currentColor'"/><path d="M9.5 10.5V12H14V13.5" stroke="currentColor"/></svg>
</template>
<script>

export default {
  name: 'IconYujingfenzu',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
